import React from "react";

// Final check D: a render error never leaves a white screen or a stack trace.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch() {}

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="flex min-h-dvh flex-col items-start justify-center gap-4 bg-bg px-6" data-testid="app-error">
        <p className="text-xl font-semibold text-ink">Une erreur est survenue.</p>
        <p className="text-[15px] text-muted">Recharge la page. Ta progression est sauvegardée.</p>
        <button type="button" onClick={() => window.location.reload()} className="min-h-11 rounded-full bg-ink px-5 text-[15px] font-medium text-bg" data-testid="app-error-reload">
          Recharger
        </button>
      </div>
    );
  }
}
